import { createCreativeStudioPdpContextAdapter } from '@frontend/store/creative-studio/chat-function-handlers/cs-pdp-adapter';
import { addPdpGridTypes, findLatestPdpGridIndex, normalizeTypeKey, TYPE_LABELS } from '@frontend/store/creative-studio/chat-function-handlers/pdp-generation-paths';

function normalizeAdapter(adapterOrContext) {
  if (adapterOrContext && typeof adapterOrContext.addAndSaveMessage === 'function') {
    return adapterOrContext;
  }
  return createCreativeStudioPdpContextAdapter(adapterOrContext);
}

export const handleAddPdpImageTypes = async ($message, adapterOrContext) => {
  const adapter = normalizeAdapter(adapterOrContext);

  let args = {};
  try {
    args = typeof $message.function_call.arguments === 'string'
      ? JSON.parse($message.function_call.arguments)
      : $message.function_call.arguments || {};
  } catch (e) {
    // fallback to empty args
  }

  const gridIndex = findLatestPdpGridIndex(adapter);
  if (gridIndex === -1) {
    await adapter.addAndSaveMessage({
      role: 'assistant',
      content: 'Start a PDP image set first, then I can add more types to it.',
    });
    return;
  }

  const requestedKeys = Array.isArray(args.image_types) ? args.image_types : [];
  const added = await addPdpGridTypes(adapter, gridIndex, requestedKeys);

  if (!added.length && requestedKeys.length) {
    const labels = requestedKeys.map(normalizeTypeKey).map((k) => TYPE_LABELS[k] || k).join(', ');

    await adapter.addAndSaveMessage({
      role: 'assistant',
      content: `${labels} ${requestedKeys.length > 1 ? 'are' : 'is'} already in this set.`,
    });
  }
};
